import React from "react";
import { FallbackProps } from "react-error-boundary";
import { useMountEffect } from "@react-hookz/web";
import { logger } from "@/libs/utils";
import GeneralError from "@/src/components/GeneralError";
import AirdropPageNotFound from "@/src/routes/404";
import { get } from "lodash";
import { ERROR_CODES } from "@/libs/error/types";
import { Button } from "nvs-design-system/dist/Button_DEPRECATED";

const ErrorBoundaryLoggerPrefix = "PROFILE ERROR BOUNDARY:";

const ProfileErrorBoundary: React.FC<FallbackProps> = ({
  error,
  resetErrorBoundary,
}) => {
  useMountEffect(() => {
    if (window !== undefined) {
      window.newrelic?.noticeError(error);
    }
    logger.error(
      `${ErrorBoundaryLoggerPrefix}: ${error.message} ${JSON.stringify(error)}`,
    );
  });

  const statusCode = get(error, "response.status");

  const notFound = statusCode === ERROR_CODES.BAD_REQUEST;

  return notFound ? (
    <AirdropPageNotFound />
  ) : (
    <GeneralError>
      <Button
        size="sm"
        className={"md:max-w-[327px] max-w-[249px] md:text-xl"}
        onClick={resetErrorBoundary}
      >
        Try Again
      </Button>
    </GeneralError>
  );
};

export default ProfileErrorBoundary;
